import { styled, withStyles } from '@material-ui/core/styles'
import {
  Card,
  Box,
  CardMedia as MuiCardMedia,
  CardActions as MUiCardActions,
  CardContent as MUiCardContent,
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
  DialogTitle as MuiDialogTitle,
  Toolbar as MuiToolbar,
  FormControl as MuiFormControl,
  IconButton as MuiIconButton,
  Menu as MuiMenu,
  Paper,
} from '@material-ui/core'
import {
  ToggleButton as MuiToggleButton,
  ToggleButtonGroup as MuiToggleButtonGroup,
} from '@mui/material'
import { grey } from '@material-ui/core/colors'

export const CardMedia = withStyles((theme) => ({
  root: {
    height: 180,
    backgroundSize: 'contain',
    margin: theme.spacing(1.4),
  },
}))(MuiCardMedia)
export const CardActions = withStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}))(MUiCardActions)
export const CardContent = withStyles((theme) => ({
  root: {
    borderTop: `1px solid ${theme.palette.grey[300]}`,
  },
}))(MUiCardContent)

export const MuiCard = withStyles((theme) => ({
  root: {
    border: '1px solid #e8e8e8',
    '& .MuiCardContent-root': {
      padding: theme.spacing(1, 2, 1),
    },
    '& .MuiTypography-h4': {
      fontSize: '0.875rem',
      fontWeight: 500,
    },
    '& .MuiTypography-body1': {
      fontSize: '0.75rem',
      fontWeight: 500,
    },
    '& .MuiButton-root': {
      minWidth: 46,
    },
  },
}))(Card)

export const MuiBox = withStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& .MuiBox-root': {
      flex: '1 1 0',
      letterSpacing: 1,
      fontSize: '0.75rem',
      fontWeight: 500,
      color: theme.palette.grey[500],
      '& .MuiTypography-root': {
        fontWeight: 500,
        display: 'inline-block',
        color: theme.palette.action,
        marginRight: theme.spacing(0.5),
      },
    },
  },
}))(Box)

export const DialogTitle = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '24px 24px 0',
    '& .MuiIconButton-root': {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  },
}))(MuiDialogTitle)

export const DialogContent = withStyles(() => ({
  root: {
    minHeight: '255px',
    borderBottom: 'none',
  },
}))(MuiDialogContent)

export const Toolbar = withStyles((theme) => ({
  root: {
    minHeight: 50,
    '& .MuiBreadcrumbs-root': {
      margin: theme.spacing(0.9, 0),
      '& .MuiTypography-root': {
        display: 'flex',
        alignItems: 'center',
        '& .MuiSvgIcon-root': {
          marginRight: theme.spacing(1.5),
        },
      },
    },
    '& .MuiGrid-item:last-child': {
      padding: theme.spacing(1),
      textAlign: 'right',
    },
  },
}))(MuiToolbar)

export const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions)

export const FormControl = withStyles((theme) => ({
  root: {
    '& .MuiInputLabel-formControl': {
      fontSize: '0.8rem',
      marginBottom: 0,
      textAlign: 'right',
    },
    [theme.breakpoints.down('sm')]: {
      position: 'absolute',
      right: 8,
      bottom: 8,
    },
  },
}))(MuiFormControl)

export const IconButton = withStyles((theme) => ({
  root: {
    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.main,
      fontSize: '1.8rem',
    },
  },
}))(MuiIconButton)

export const Menu = withStyles((theme) => ({
  paper: {
    border: `1px solid ${theme.palette.grey[300]}`,
    boxShadow: `1px 1px 12px 0 ${theme.palette.grey[400]}`,
  },
}))(MuiMenu)

export const MenuPaper = styled(Paper)({
  border: `1px solid ${grey[300]}`,
  boxShadow: `1px 1px 12px 0 ${grey[400]}`,
})

export const StyledToggleButtonGroup = withStyles(() => ({
  root: {
    backgroundColor: '#f5f5f5',
    borderRadius: '25px !important',
    padding: '3px',
    display: 'flex',
    width: '200px',
    height: '40px',
    overflow: 'hidden',
    '& .MuiToggleButtonGroup-grouped': {
      border: 'none',
      textTransform: 'none',
    },
  },
}))(MuiToggleButtonGroup)

export const StyledToggleButton = withStyles(() => ({
  root: {
    flex: 1,
    borderRadius: '25px !important',
    textTransform: 'none',
    fontWeight: 'normal',
    backgroundColor: 'transparent',
    border: 'none',
    padding: '6px 12px',
    transition: 'background-color 0.5s ease',
    '&:hover': {
      backgroundColor: 'transparent !important',
    },
    '&.Mui-selected, &.Mui-selected:hover': {
      backgroundColor: 'white !important',
    },
  },
}))(MuiToggleButton)
